import { defineComponent, reactive, watch } from "@vue/composition-api";
import './index.scss'
import _ from 'lodash'
import VueI18n from "vue-i18n";
const SingLineContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    i18n:{
      type:VueI18n
    }
  },
  setup(props, context) {
    const { emit } = context;
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: ''
    })

    watch(() => props.item, (val) => {
      state.editItem = _.cloneDeep(val);
    }, {
      deep: true
    })
    const elInputChange = (value) => {
      state.editItem.value = value;
      state.editItem.isShowTitleError = false;
      emit('answer', state.editItem);
    }
    return () => {
      return (
        <div class='fill-topic-content'>
          <el-input
            style={{width: '100%'}}
            onInput={value => elInputChange(value)} value={state.editItem.value}
            maxlength={props.item.topicSetting.textLessThan}
            size='small'
            placeholder={props.i18n?.t('survy.plccontent')}></el-input>
        </div>
      )
    }
  }
})

export default SingLineContent
